import { createFileRoute } from '@tanstack/react-router';
import { settingsSearchSchema } from 'src/modules/settings/schemas/settings.schema';
import { FunnelsSettingsPage } from 'src/modules/settings/components/pages/funnels-settings.page';

export const Route = createFileRoute('/settings/funnels')({
  component: FunnelsSettingsPage,
  validateSearch: (search) => settingsSearchSchema.parse(search),
});
